import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { Meta } from '@/lib/api';

export interface PaginationProps {
  meta: Meta;
  pageSize: number;
  onPageChange: (page: number) => void;
}

export function Pagination({ meta, pageSize, onPageChange }: PaginationProps) {
  const { total, page, pages } = meta;
  if (total === 0) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-col items-center justify-between gap-3 border-t pt-4 sm:flex-row">
      <div className="text-xs text-muted-foreground">
        Hiển thị <span className="font-semibold tabular-nums text-foreground">{start}</span>–
        <span className="font-semibold tabular-nums text-foreground">{end}</span> trong số{' '}
        <span className="font-semibold tabular-nums text-foreground">{total.toLocaleString('vi-VN')}</span>{' '}
        SKUs
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          <ChevronLeft className="h-4 w-4" />
          Trước
        </Button>
        <div className="text-xs text-muted-foreground">
          Trang <span className="font-semibold text-foreground">{page}</span> /{' '}
          <span className="">{pages}</span>
        </div>
        <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => onPageChange(page + 1)}>
          Sau
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
